<ng-container *ngIf="credentials">

  <div class="row no-gutters mt-2 mb-4">
    <div class="col-12">
      <mat-button-toggle-group appearance="legacy"
                               [(ngModel)]="selectedCredentialsAssignment"
                               class="dr-boolean-toggle"
                               aria-label="Credentials Assignment">
        <mat-button-toggle *ngFor="let assignment of CredentialsAssignments.ALL"
                           id="{{idPrefix}}select_assignment.{{assignment.key}}"
                           [value]="assignment">
          {{ assignment.trans | translate | uppercase }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <div class="row no-gutters">

    <div class="col-sm-12 col-md-9">
      <div class="info-message mb-3" *ngIf="!advancedCredentialGroup">
        <span id="{{idPrefix}}info_basic.title" class="title">
           {{ 'third_party_credentials_management.message.basic_title' | translate }}
        </span>
        <br/>
        <span id="{{idPrefix}}info_basic.text">
            {{ 'third_party_credentials_management.message.basic' | translate }}
        </span>
      </div>
      <div class="info-message" *ngIf="advancedCredentialGroup">
        <span id="{{idPrefix}}info_advanced.title" class="title">
           {{ 'third_party_credentials_management.message.advanced_title' | translate }}
        </span>
        <br/>
        <span id="{{idPrefix}}info_advanced.text">
          {{ 'third_party_credentials_management.message.advanced' | translate: { advanced_type: (credentials.assignment === CredentialsAssignment.OFFICES ? 'third_party_credentials_management.title.office' : 'third_party_credentials_management.title.user') | translate | uppercase } }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-3 pl-3">
      <mat-form-field class="full-width"
                      *ngIf="advancedCredentialGroup">
        <mat-label>{{ 'common.label.search' | translate }}</mat-label>
        <input id="{{idPrefix}}search"
               type="text" matInput
               [(ngModel)]="filter.searchText">
        <button id="{{idPrefix}}btn.clear_search"
                mat-button
                matSuffix mat-icon-button
                aria-label="'common.label.search' | translate"
                *ngIf="filter.searchText"
                (click)="filter.searchText = ''">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

  </div>

  <mat-accordion class="full-width">

    <!-- MASTER CREDENTIALS -->
    <mat-expansion-panel id="{{idPrefix}}basic" class="mt-2" [expanded]="true">
      <mat-expansion-panel-header class="main-credentials" (click)="selectedAdvancedCredentials = null">
        <mat-panel-title id="{{idPrefix}}basic.header_title">
          {{ 'third_party_credentials_management.title.main_credentials' | translate }}
          <i *ngIf="credentials.basic.credentialsComplete()" class="fas fa-check"></i>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <email-credentials *ngIf="credentials.id === CredentialType.EMAIL"
                         [idPrefix]="(idPrefix + 'basic.')"
                         [(bananaBox)]="credentials.basic"
                         [emailProviders]="emailProviders"
                         (cancel)="cancel()"
                         (save)="save()"
                         (testMailResponse)="handleTestEmailResponse($event)">
      </email-credentials>

    </mat-expansion-panel>

    <!-- ADVANCED CREDENTIALS -->
    <ng-container *ngIf="advancedCredentialGroup">

      <mat-expansion-panel class="mt-2"
                           *ngFor="let advancedCred of filter.filteredArray; let i = index"
                           id="{{idPrefix}}{{selectedCredentialsAssignment.key}}.cred_{{i}}"
                           [expanded]="selectedAdvancedCredentials && advancedCred.id === selectedAdvancedCredentials.id">
        <mat-expansion-panel-header (click)="selectAdvancedCredentials(advancedCred)">
          <mat-panel-title id="{{idPrefix}}{{selectedCredentialsAssignment.key}}.cred_{{i}}.header_title">
            {{ (credentials.assignment === CredentialsAssignment.OFFICES ? 'third_party_credentials_management.title.office' : 'third_party_credentials_management.title.user') | translate }}: {{ advancedCred.name }}
            <i *ngIf="advancedCred.credentialsComplete()" class="fas fa-check"></i>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <email-credentials *ngIf="credentials.id === CredentialType.EMAIL"
                           [idPrefix]="(idPrefix + selectedCredentialsAssignment.key + '.cred_' + i + '.')"
                           [(bananaBox)]="filter.filteredArray[i]"
                           [emailProviders]="emailProviders"
                           (cancel)="cancelAdvancedCredentials(filter.filteredArray[i])"
                           (save)="saveAdvancedCredentials(filter.filteredArray[i])"
                           (testMailResponse)="handleTestEmailResponse($event)">
        </email-credentials>

      </mat-expansion-panel>

    </ng-container>
  </mat-accordion>

</ng-container>
